import { lens3m3nj3zkwtu6r as lens } from '../lensing/abstracts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens_0,
  lens26es9640ifscs as lens_1,
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ReactiveMutableList$reactiveContains$1Class;
function ReactiveMutableList$reactiveContains$1() {
  if (ReactiveMutableList$reactiveContains$1Class === VOID) {
    class $ {
      constructor(this$0, $element) {
        this.ham_1 = this$0;
        this.iam_1 = $element;
        var tmp = this;
        tmp.gam_1 = lens(this$0, (it) => it.t1($element));
      }
      vah(listener) {
        return this.gam_1.vah(listener);
      }
      jam(value) {
        if (value)
          this.ham_1.nam(this.iam_1);
        else
          this.ham_1.mam(this.iam_1);
      }
      oam(_set____db54di) {
        return this.jam((!(_set____db54di == null) ? typeof _set____db54di === 'boolean' : false) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.gam_1.f2();
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens_0;
    protoOf($).dak = lens_1;
    protoOf($).sah = get_state;
    protoOf($).kaj = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue()], [1]);
    ReactiveMutableList$reactiveContains$1Class = $;
  }
  return ReactiveMutableList$reactiveContains$1Class;
}
var ReactiveMutableListClass;
function ReactiveMutableList() {
  if (ReactiveMutableListClass === VOID) {
    class $ extends BaseListenable() {
      static tam(list) {
        var $this = this.uam();
        $this.lam_1 = list;
        return $this;
      }
      static vam() {
        return this.tam(ArrayList().w());
      }
      static wam(items) {
        return this.tam(ArrayList().b1(items));
      }
      static xam(startingItems) {
        return this.tam(ArrayList().b1(asList(startingItems)));
      }
      yam(value) {
        this.lam_1.v3();
        this.zam(value);
      }
      oam(_set____db54di) {
        return this.yam((!(_set____db54di == null) ? isInterface(_set____db54di, KtList()) : false) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.lam_1;
      }
      v3() {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.lam_1.i1()) {
          // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
          this.lam_1.v3();
          // Inline function 'kotlin.also' call
          this.mal();
        }
      }
      z3(index) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.z3(index);
        this.mal();
        return this_0;
      }
      fm(index, element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.b2(index, element);
        this.mal();
        return this_0;
      }
      b2(index, element) {
        return this.fm(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      aan(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signalChange' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.x3(elements);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      x3(elements) {
        return this.aan(elements);
      }
      ban(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signalChange' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.w2(elements);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      w2(elements) {
        return this.ban(elements);
      }
      zam(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signalChange' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.r1(elements);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      r1(elements) {
        return this.zam(elements);
      }
      gm(index, element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        this.lam_1.y3(index, element);
        // Inline function 'kotlin.also' call
        this.mal();
        return Unit_instance;
      }
      y3(index, element) {
        return this.gm(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      nam(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.v(element);
        this.mal();
        return this_0;
      }
      v(element) {
        return this.nam((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      mam(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signalChange' call
        // Inline function 'kotlin.also' call
        var this_0 = this.lam_1.w3(element);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      w3(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.mam((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      can(element) {
        return new (ReactiveMutableList$reactiveContains$1())(this, element);
      }
      u1(index) {
        return this.lam_1.u1(index);
      }
      m3(fromIndex, toIndex) {
        return this.lam_1.m3(fromIndex, toIndex);
      }
      i1() {
        return this.lam_1.i1();
      }
      kl(element) {
        return this.lam_1.t1(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.kl((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        return this.lam_1.m1();
      }
      dan(elements) {
        return this.lam_1.l3(elements);
      }
      l3(elements) {
        return this.dan(elements);
      }
      q1(index) {
        return this.lam_1.q1(index);
      }
      ean(element) {
        return this.lam_1.s1(element);
      }
      s1(element) {
        if (!(element == null ? true : !(element == null)))
          return -1;
        return this.ean((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      p1() {
        return this.lam_1.p1();
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
    }
    protoOf($).iah = set;
    protoOf($).eak = valueSet;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens_0;
    protoOf($).dak = lens_1;
    protoOf($).sah = get_state;
    initMetadataForClass($, 'ReactiveMutableList', $.vam, VOID, [KtMutableList(), MutableReactiveValue(), BaseListenable()], [1]);
    ReactiveMutableListClass = $;
  }
  return ReactiveMutableListClass;
}
//region block: exports
export {
  ReactiveMutableList as ReactiveMutableList2gg4x024enrbf,
};
//endregion

//# sourceMappingURL=ReactiveMutableList.mjs.map
